<template>
  <div class="project-outbox">
    <div class="project">
      <div class="title">角色管理</div>
      <div class="pro-info">
        <div class="right">
          <el-input v-model="form.searchName" prefix-icon="el-icon-search" clearable placeholder="请输入角色名称"></el-input>
          <el-button type="primary" size="small" @click="onSearch">搜索</el-button>
        </div>
        <div class="left">
          <el-button type="primary" @click="addForm">添加角色</el-button>
        </div>
      </div>

      <div class="table">
        <div class="table_bd">
          <el-table v-loading="tableLoading" :data="tableData" max-height="100%">
            <el-table-column type="index" label="编号" width="70">
            </el-table-column>
            <el-table-column v-for="(item, index) in tableField" :key="index" :prop="item.prop" :label="item.label"
              align="center">
            </el-table-column>
            <el-table-column prop="address" label="编辑" align="center">
              <template slot-scope="scope">
                <el-button class="text-primary" @click="permissionConfig(scope.row.id)" type="text" size="small">
                  权限配置
                </el-button>
                <el-button class="text-primary" v-if="[-1,1,2,3,4,5,6].indexOf(scope.row.id) == -1"
                  @click="handleEditClick(scope.row)" type="text" size="small">
                  编辑
                </el-button>
                <el-button class="text-danger" v-if="[-1,1,2,3,4,5,6].indexOf(scope.row.id) == -1"
                  @click="handleDelClick(scope.row)" type="text" size="small">
                  删除
                </el-button>
              </template>
            </el-table-column>

          </el-table>
          <el-pagination class="m-t-lg" @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="currentPage" align="right" background :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="total">
          </el-pagination>
        </div>
      </div>
      <!-- 权限配置tree -->
      <el-dialog :visible.sync="dialogTreeVisible" title="权限配置" center :modal-append-to-body='false'>
        <div slot="footer" v-loading="treeLoading" v-show="dialogTreeVisible">
          <form action="#">
            <ul id="tree_list"></ul>
          </form>
          <span slot="footer" class="dialog-footer">
            <el-button class="form_btn" @click="dialogTreeVisible = false">取消</el-button>
            <el-button class="form_btn m-l-60" type="primary" @click="addRoleTree">保存</el-button>
          </span>
        </div>
      </el-dialog>

      <el-dialog :visible.sync="dialogAddVisible" title="新增角色" center :modal-append-to-body='false'>
        <div slot="footer" v-loading="treeLoading" v-show="dialogAddVisible">
          <el-form action="#" :model="roleForm" :rules="rules" ref="roleForm">
            <el-form-item label="角色名称" prop="roleName">
              <el-input v-model="roleForm.roleName"></el-input>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button class="form_btn" @click="dialogAddVisible = false">取消</el-button>
            <el-button class="form_btn m-l-60" type="primary" @click="submitAddForm">保存</el-button>
          </span>
        </div>
      </el-dialog>

      <el-dialog :visible.sync="dialogEditVisible" title="编辑角色" center :modal-append-to-body='false'>
        <div slot="footer" v-loading="treeLoading" v-show="dialogEditVisible">
          <el-form action="#" :model="roleForm" :rules="rules" ref="roleForm">
            <el-form-item label="角色名称" prop="roleName">
              <el-input v-model="roleForm.roleName"></el-input>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button class="form_btn" @click="dialogEditVisible = false">取消</el-button>
            <el-button class="form_btn m-l-60" type="primary" @click="submitEditForm">保存</el-button>
          </span>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
  import qs from 'qs'
  import {
    Message
  } from 'element-ui';
  export default {
    resourceName: 'userList',
    data () {
      return {
        currentPage: 1,
        pageSize: 10,
        total: 0,
        form: {
          searchName: ''
        },
        tableLoading: true,
        treeLoading: false,
        RoleResources: [],
        roleSelectIds: [],
        dialogTreeVisible: false,
        dialogAddVisible: false,
        dialogEditVisible: false,
        type: 0,
        typeTitle: '添加角色',
        roleForm: {
          id: 0,
          roleName: '',
          roleDescribe: ''
        },
        rules: {
          roleName: [
            { required: true, message: '请输入角色名称', trigger: 'blur' },
            { min: 1, max: 10, message: '长度在 3 到 5 个字符', trigger: 'blur' }
          ]
        },
        tableData: [],
        leafNodesLevel: {
          level_leaf_status: [],
          level: [],
          levelMax: 0
        },
        leafNodes: [],
        roleId: 0,
        serviceName: '配电平台',
        verTree: {},
        tableField: [
          {
            label: '角色名称',
            prop: 'roleName'
          },
          {
            label: '添加时间',
            prop: 'createTime'
          }
        ]
      }
    },
    created () {
      this.searchRoleList()
    },
    methods: {
      searchRoleList () {
        let that = this
        that.tableLoading = true
        // 获取权限列表
        const params = {
          currentPage: that.currentPage,
          roleName: that.form.searchName,
          size: that.pageSize
        }
        let url = 'bma-user-service/role/searchAllRoleList'
        that.$http
          .post(
            url,
            params
          )
          .then(function (res) {
            // console.log(res)
            that.tableData = res.data.records
            that.total = res.data.total
            that.tableLoading = false
          })
          .catch(function (err) {
            // console.log(err)
            that.tableLoading = false
          })
      },
      // 获取权限配置
      permissionConfig (id) {
        const that = this
        that.roleId = id
        that.treeLoading = true
        that.dialogTreeVisible = true
        that.searchRoleResourcesForSuper(id)
      },
      searchRoleResourcesForSuper (id) {
        const that = this
        let treeList = document.getElementById('tree_list')
        treeList.innerHTML = ''
        let url = 'bma-user-service/role/searchRoleResources'
        that.$http
          .post(
            url,
            { roleId: id }
          )
          .then(function (res) {
            that.RoleResources = res.data
            // console.log('这是返回的数据')
            // 选中的id let vv
            that.roleSelectIds = that.filterResIds(that.reduceList(res.data))

            /* eslint-disable */
            new verTree({
              /* eslint-enable */
              items: '#tree_list',
              type: 'form', // list:表格展示 data:一般展示 form：表单展示
              // data: treeDate,
              data: that.RoleResources,
              parent: 'parentId',
              params: 'resourceId',
              value: 'resourceName',
              open_close: 'close',
              // 已经勾选的是全部的数据
              // defaults: selectId
              defaults: that.roleSelectIds
            })
            // console.log(that.roleSelectIds)
            that.treeLoading = false
          })
          .catch(function (err) {
            // console.log(err)
            that.treeLoading = false
          })
      },
      // 筛选出指定的函数
      filterResIds (res) {
        const selectedRes = []
        // console.log(res)
        if (res) {
          res.forEach((item) => {
            if (item.isChecked) {
              selectedRes.push(item.resourceId.toString())
            }
          })
          return selectedRes
        }
      },
      // 多维数组扁平化数组
      reduceList (array, { childrenKeys } = {}) {
        childrenKeys = childrenKeys || ['children']
        const selectedList = []
        array.forEach((item) => {
          const flattenItem = item
          selectedList.push(flattenItem)
          childrenKeys.forEach((key) => {
            if (item[key] && Array.isArray(item[key])) {
              const children = this.reduceList(item[key], {
                childrenKeys
              })
              selectedList.push(...children)
            }
          })
        })
        return selectedList
      },
      // 选中配置权限
      addRoleTree () {
        const that = this
        let ids = ''
        // console.log('进入了')
        let checkList = document.getElementsByClassName('icon-check-box-cicre')
        for (var i = 0; i < checkList.length; i++) {
          let selectVlaue = checkList[i].nextElementSibling.value
          ids += selectVlaue + ','
        }
        // console.log(ids)
        let url = 'bma-user-service/role/managerDisRoleResource'
        that.$http
          .post(
            url, {
            resourceIds: ids.slice(0, -1),
            roleId: that.roleId
          }

          )
          .then(function (res) {
            that.dialogTreeVisible = false
            Message({
              showClose: true,
              message: res.data,
              type: 'success'
            })
          })
          .catch(function (err) {
            // console.log(err)
            that.dialogTreeVisible = false
          })
      },
      // 添加或者编辑角色
      onSearch () {
        this.currentPage = 1
        this.searchRoleList()
      },
      handleSizeChange (val) {
        this.pageSize = val;
        this.searchRoleList();
      },
      handleCurrentChange (val) {
        this.currentPage = val;
        this.searchRoleList();
      },
      addForm () {
        this.roleForm.id = 0
        this.roleForm.roleName = ''
        this.dialogAddVisible = true
      },
      submitAddForm () {
        let that = this

        this.$refs["roleForm"].validate((valid) => {
          if (valid) {
            let url = 'bma-user-service/role/addRole'
            this.roleForm.dataType = "1";
            this.$http.post(url, this.roleForm)
              .then(function (res) {

                if (res.code == 200) {
                  that.searchRoleList()
                  that.dialogAddVisible = false
                }


              })


          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      handleDelClick (row) {
        // 删除
        const that = this;
        that
          .$confirm("确定要删除此角色吗？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
          .then(() => {
            this.$http
              .post("bma-user-service/role/deleteRole", {
                roleId: row.id,
              })
              .then(function (res) {
                Message({
                  showClose: true,
                  message: res.data,
                  type: "success",
                });
                that.searchRoleList()
              })
              .catch(function (err) {
                console.log(err);
              });
          })
          .catch(() => { });
      },
      handleEditClick (row) {
        this.roleForm.id = row.id
        this.roleForm.roleName = row.roleName
        this.dialogEditVisible = true
      },
      submitEditForm () {

        let that = this

        this.$refs["roleForm"].validate((valid) => {
          if (valid) {
            let url = 'bma-user-service/role/updateRole'
            this.roleForm.dataType = "1";
            this.$http.post(url, this.roleForm)
              .then(function (res) {

                if (res.code == 200) {
                  that.searchRoleList()
                  that.dialogEditVisible = false
                }


              })


          } else {
            console.log('error submit!!');
            return false;
          }
        });
      }
    },
    watch: {
      // // 关闭权限配置
      dialogTreeVisible (v) {
        if (!v) {
          this.RoleResources = []
          this.searchRoleResourcesForSuper(this.roleId)
        }
      },
    }
  }
</script>
<style lang="less" scoped>
  #tree_list ul {
    padding-left: 40px;
  }

  .project-outbox {
    padding: 20px;
  }

  .project {
    background: #f8f8f9;
    border-radius: 7px;
    padding: 24px;

    .title {
      font-size: 18px;
      color: #0e223d;
      letter-spacing: 2px;
      font-weight: 600;
    }

    .pro-info {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 30px;
      margin-bottom: 28px;
      z-index: 2000;
      position: relative;

      .left {
        font-size: 16px;
        color: #0e223d;

        span {
          &:last-of-type {
            font-weight: 600;
          }
        }
      }

      .right {
        display: flex;

        .el-input {
          margin-right: 10px;
        }

        .search {
          margin-right: 20px;
        }
      }
    }

    .table-box {
      .el-table {
        background: rgba(0, 0, 0, 0);

        th,
        tr {
          background: rgba(0, 0, 0, 0);
        }

        th {
          >.cell {
            color: #152139;
            font-size: 14px;
            font-weight: 600;
            text-align: center;
          }
        }

        tr {
          td {
            text-align: center;
            font-size: 14px;
            color: #152139;
          }
        }

        .btn-out-box {
          display: flex;
          justify-content: space-around;
        }

        .btn-box {
          width: 24px;
          height: 24px;
          background: rgba(165, 165, 165, 0.1);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;

          .iconfont {
            font-size: 12px;
            color: rgba(195, 195, 195, 1);
          }

          &.download.active {
            background: rgba(31, 207, 138, 0.1);

            .iconfont {
              color: rgba(31, 207, 138, 1);
            }
          }

          &.editself.active {
            background: rgba(20, 96, 224, 0.1);

            .iconfont {
              color: rgba(20, 96, 224, 1);
            }
          }
        }
      }
    }

    .el-pagination {
      text-align: center;
      margin-top: 30px;
    }

    .el-dialog {
      width: 35%;

      .el-dialog__title {
        font-weight: 600;
      }

      .el-input {
        // width: 323px;
      }

      .line {
        text-align: center;
      }
    }
  }
</style>